import React from "react";
import "./HomeOurServiceSec.css";

const HomeOurServiceSec = ({ currentLanguage = "en" }) => {
  const isFrench = currentLanguage === "fr";

  // ENGLISH DATA
  const dataEN = [
    {
      title: "Audit and Assurance",
      items: [
        "Financial Statement Audit",
        "IFRS Advisory Service",
        "Other Assurance Service",
        "Internal Control Framework",
      ],
    },
    {
      title: "Advisory",
      items: [
        "Deal Advisory",
        "Restructuring",
        "Due Diligence",
        "Forensic Services",
        "Risk Advisory",
        "Technology Advisory Service",
        "Valuations",
      ],
    },
    {
      title: "Taxation",
      items: [
        "Corporate Tax",
        "Merger And Acquisition",
        "Transfer Pricing",
        "Value Added Tax",
        "International Tax",
        "Excise Tax",
        "Tax Restructuring",
        "Economic Substance Regulations",
      ],
    },
    {
      title: "Business Service Outsourcing",
      items: [
        "Finance And Accounting",
        "Corporate Advisory Services",
        "Expenses Claim Management",
        "Payroll & HR Services",
        "Secondment",
        "Treasury Service",
      ],
    },
    {
      title: "Strategies",
      items: ["Market Research", "Business Consulting"],
    },
    {
      title: "Corporate Services",
      items: [
        "Entity Set-Up",
        "Outsourced Finance & Regulatory Compliance",
        "Company Secretarial",
      ],
    },
  ];

  // FRENCH DATA
  const dataFR = [
    {
      title: "Audit et Assurance",
      items: [
        "Audit des États Financiers",
        "Conseil IFRS",
        "Autres Services d'Assurance",
        "Cadre de Contrôle Interne",
      ],
    },
    {
      title: "Conseil",
      items: [
        "Conseil en Transactions",
        "Restructuration",
        "Due Diligence",
        "Services Forensiques",
        "Conseil en Risques",
        "Conseil en Technologies",
        "Évaluations",
      ],
    },
    {
      title: "Fiscalité",
      items: [
        "Impôt sur les Sociétés",
        "Fusions et Acquisitions",
        "Prix de Transfert",
        "Taxe sur la Valeur Ajoutée",
        "Fiscalité Internationale",
        "Droits d'Accise",
        "Restructuration Fiscale",
        "Réglementations sur la Substance Économique",
      ],
    },
    {
      title: "Externalisation des Services d'Entreprise",
      items: [
        "Finance et Comptabilité",
        "Services de Conseil d'Entreprise",
        "Gestion des Notes de Frais",
        "Services RH et Paie",
        "Détachement",
        "Service de Trésorerie",
      ],
    },
    {
      title: "Stratégies",
      items: ["Étude de Marché", "Conseil d'Entreprise"],
    },
    {
      title: "Services Corporatifs",
      items: [
        "Création d'Entité",
        "Finance Externalisée et Conformité Réglementaire",
        "Secrétariat Juridique",
      ],
    },
  ];

  // Select data based on language
  const data = isFrench ? dataFR : dataEN;

  // Translation for section headings
  const translations = {
    en: {
      subtitle: "OUR EXPERTISE",
      title: "WHAT WE DELIVER",
    },
    fr: {
      subtitle: "NOTRE EXPERTISE",
      title: "CE QUE NOUS OFFRONS",
    },
  };

  const t = isFrench ? translations.fr : translations.en;

  return (
    <section className="service-wrapper section">
      {/* Section Heading */}
      <div className="text-center mb-5">
        <div className="d-flex align-items-center justify-content-center mb-2">
          <div className="services-line me-3"></div>
          <h6 className="service-subtitle mb-0">{t.subtitle}</h6>
        </div>
        <h2 className="service-title">{t.title}</h2>
      </div>

      {/* Services Grid */}
      <div className="homeServicemainBox">
        {data.map((col, index) => (
          <div key={index} className="mb-4 servie-main-div">
            <div className="service-column">
              <h4 className="service-col-title">{col.title}</h4>

              {/* Divider except first column */}
              <div className="service-divider"></div>

              <ul className="service-list">
                {col.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeOurServiceSec;